{
  "asset_id": "1309ee8e-1e36-4128-a085-a22c1c484db0",
  "content_type": "image/jpeg",
  "created_at": "2026-09-07T20:12:30Z",
  "original_filename": "h2j-team.jpg",
  "project_id": "2e05451c-9ac5-4503-b5ea-624bd8d09e1e",
  "r2_key": "a/v1/2e05451c-9ac5-4503-b5ea-624bd8d09e1e/1309ee8e-1e36-4128-a085-a22c1c484db0/h2j-team.jpg",
  "size": 120140,
  "url": "/__l5e/assets-v1/1309ee8e-1e36-4128-a085-a22c1c484db0/h2j-team.jpg",
  "version": 1
}